export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "container_attachment": {
            "exporter_process_container_file_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de adjunto"])},
            "container_attach": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjunto"])},
            "container_attach_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre del archivo"])}
          }
        }
      },
      "en": {
        "model": {
          "container_attachment": {
            "exporter_process_container_file_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attachment type"])},
            "container_attach": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attachment"])},
            "container_attach_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attachment name"])}
          }
        }
      }
    }
  })
}